import { Box } from "../../primitives";
import { styled } from "../../../stitches.config";
import { ScrollStyles } from "../common.style";

export const Overlay = styled(Box, {
  position: "fixed",
  inset: 0,
  backgroundColor: "rgba(0, 0, 0, 0.6)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 1000,
});

export const ModalStyled = styled(Box, {
  backgroundColor: "#f0fdf4",
  borderRadius: 12,
  padding: 24,
  maxWidth: 1200,
  width: "90%",
  maxHeight: "90vh",
  overflowY: "auto",
  position: "relative",
  boxShadow: "0 10px 25px rgba(0,0,0,0.25)",
  animation: "fadeIn 0.2s ease-in-out",
  display: "flex",
  flexDirection: "column",
  ...ScrollStyles,
});

export const CloseBtn = styled("button", {
  position: "absolute",
  top: 12,
  right: 16,
  background: "none",
  border: "none",
  fontSize: 24,
  cursor: "pointer",
  color: "#888",
});
